// This WebAudioRecorder is needed for Safari for now, because Safari doesn't
// yet support the WebCodecs audio API.
import { Settings } from '@streamr/tv-engine';
import { EventEmitter } from 'eventemitter3';
import * as audioRecorderProcessor from './workers/webaudiorecorder.worklet';
export class WebAudioRecorder extends EventEmitter {
    audioContext;
    audioSource;
    audioWorklet;
    initialized = false;
    performanceNowAtFirstFrameMicros = -1;
    frameCounter = 0;
    constructor() {
        console.log('WebAudioRecorder constructor');
        super();
    }
    async initialize() {
        if (this.initialized)
            return;
        this.audioContext = new AudioContext({
            sampleRate: Settings.audioSampleRate,
        });
        await this.audioContext.audioWorklet.addModule(
        // biome-ignore lint/suspicious/noExplicitAny: @todo fix types (the "any")
        audioRecorderProcessor);
        this.initialized = true;
    }
    async start(audioTrack) {
        try {
            await this.initialize();
            if (!this.audioContext) {
                throw new Error('AudioContext not initialized');
            }
            // Create a promise that will be resolved when the first data is emitted
            const firstDataPromise = new Promise((resolve) => {
                const onFirstData = () => {
                    resolve();
                };
                this.once('data', onFirstData);
            });
            // Create media stream source
            this.audioSource = this.audioContext.createMediaStreamSource(new MediaStream([audioTrack]));
            // Create and configure worklet
            this.audioWorklet = new AudioWorkletNode(this.audioContext, 'audio-recorder-processor');
            // Handle messages from the audio worklet
            this.audioWorklet.port.onmessage = (event) => {
                if (event.data.samples) {
                    if (this.performanceNowAtFirstFrameMicros === -1) {
                        this.performanceNowAtFirstFrameMicros = Math.round((performance.now() + performance.timeOrigin) *
                            1_000);
                        console.log('WebAudioRecorder start() performanceNowAtFirstFrameMillis', this.performanceNowAtFirstFrameMicros / 1_000);
                    }
                    const timestamp = this.frameCounter *
                        Settings.audioFrameDurationMicroseconds;
                    this.emit('data', timestamp, event.data.samples);
                    this.frameCounter++;
                }
            };
            // Connect the audio graph
            this.audioSource.connect(this.audioWorklet);
            this.audioWorklet.connect(this.audioContext.destination);
            await firstDataPromise;
        }
        catch (error) {
            console.error('Failed to start audio recording:', error);
            throw error;
        }
    }
    async stop() {
        if (this.audioWorklet) {
            this.audioWorklet.disconnect();
            this.audioWorklet = undefined;
        }
        if (this.audioSource) {
            this.audioSource.disconnect();
            this.audioSource = undefined;
        }
        if (this.audioContext) {
            await this.audioContext.close();
            this.audioContext = undefined;
        }
        this.initialized = false;
    }
}
